<template>
  <div>
    <b-modal
      id="modal-type-response-chat"
      ref="modal-flux-ext"
      :title="title"
      ok-title="Salvar"
      cancel-variant="outline-secondary"
      centered
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        @submit.stop.prevent="handleSubmit"
      >
        <b-form-group
          :state="nameState"
          label-for="name-input"
        >
          <template #label>
            <span>Name do campo</span>
            <feather-icon
              v-b-popover.hover.v-dark.top="'Este campo não aceita acentuação e pontuação e nem caracteres especiais.'"
              icon="HelpCircleIcon"
              style="margin-left: 3px; margin-bottom: 3px;"
              size="13"

              class="align-middle icon-help-type-input"
            />
          </template>

          <b-form-input
            id="name-input"
            v-model="menssagemChatFlux.label"
            placeholder="Nome deste campo"
            :state="nameState"
            required
            @input="$emit('update:messageChat', menssagemChatFlux) "
          />
          <b-form-invalid-feedback :state="nameState">
            Nome do campo não pode ficar em branco.
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="d-flex align-items-center">
          <b-form-checkbox
            v-model="menssagemChatFlux.obrigatorio"
            :value="1"
            :unchecked-value="0"
            class="custom-control-success"
            name="check-button"
            switch
            @input="$emit('update:messageChat', menssagemChatFlux)"
          />
          Campo obrigatórios
        </div>
        <div
          v-if="messageChat.type === 2"
          class="d-flex align-items-center mt-1"
        >
          <b-form-checkbox
            v-model="menssagemChatFlux.whatsApp"
            :value="1"
            :unchecked-value="0"
            class="custom-control-success"
            name="check-button"
            switch
            @input="$emit('update:messageChat', menssagemChatFlux)"
          />
          WhatsApp
        </div>
        <div class="d-flex align-items-center mt-1">
          <b-form-checkbox
            v-model="menssagemChatFlux.startGPT"
            :value="1"
            :unchecked-value="0"
            class="custom-control-success"
            name="check-button"
            switch
            @input="$emit('update:messageChat', menssagemChatFlux)"
          />
          Start ChatGPT
        </div>
        <div>
          <b-card
            id="cad-info-required"
            border-variant="dark"
            class="mb-0 mt-1"
          >
            <b-card-text class="p-0">Campos obrigatórios funcionam como um filtro, você não receberá os leads que não
              responderem a essa pergunta.
            </b-card-text>
          </b-card>
        </div>

      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  model: {
    prop: 'messageChat',
    event: 'update:messageChat',
  },
  props: {
    title: {
      type: String,
      default: 'Modal Title',
    },
    messageChat: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    name: '',
    nameState: null,
    submittedNames: [],
  }),
  computed: {
    menssagemChatFlux: {
      get() {
        return this.messageChat
      },
      set(value) {
        this.$emit('update:messageChat', value)
      },
    },
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.$emit('submit', {
        ...this.menssagemChatFlux,
      })
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['modal-flux-ext'].toggle('#toggle-btn')
      })
    },
  },
}
</script>

<style scoped lang="scss">
.icon-help-type-input:hover {
  cursor: pointer;
  background-color: #1ab7ea;
  border-radius: 50%;
  stroke: #fff;
}

.icon-help-type-input {
  stroke: #7e8896;
}

#cad-info-required {
  div.card-body {
    padding: 0.5rem 1rem;
  }
}
</style>
